import keyMirror from 'keymirror';

export const INVITATION_STATUSES = keyMirror({
  accepted: null,
  pending: null,
  rejected: null,
});

export const INVITATION_ACTIONS = keyMirror({
  accept: null,
  reject: null,
});

export const INVITATION_ERROR_CODES = keyMirror({
  INVALID_SHAREABLE_TOKEN: null,
  REQUIRES_AUTHENTICATION: null,
});

export const INVITATION_TYPES = keyMirror({
  direct: null,
  shareable: null,
});
